import { AppBar as MuiAppBar, AppBarProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { AppBarProps };

export const AppBar: React.ComponentType<AppBarProps> = styled(MuiAppBar)<AppBarProps>(() => ({}));
